import { Stack, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { NoResultsIllustration } from "assets/illustration_no_results";
import { audienceKey } from "./matchAudience";
import type { MatchAudience } from "./matchAudience";

type NoBuyersFoundIllustrationProps = {
  /** Buyers (sale) vs renters (rent) — copy only. Defaults to buyers. */
  audience?: MatchAudience;
};

export function NoBuyersFoundIllustration({
  audience = "buyers"
}: NoBuyersFoundIllustrationProps = {}): JSX.Element {
  const { t: translate } = useTranslation();

  return (
    <Stack alignItems="center" gap={2}>
      <NoResultsIllustration />
      <Typography variant="subtitle1">
        {translate(audienceKey(audience, "error.noBuyersFound"))}
      </Typography>
    </Stack>
  );
}
